import { Dispatch, memo } from 'react'
import 'swiper/css'
import 'swiper/css/a11y'
import { Swiper, SwiperSlide } from 'swiper/react'

import { CardType } from '../../../types/types'
import { ProductImage } from '../../product-image/product-image'

import cl from './swiper-el.module.scss'

type SwiperProps = {
	type?: CardType
	images?: string[]
	alt?: string
	speed?: number
	handleSlideChange?: () => void
	setSwiperInstance?: Dispatch<any> // eslint-disable-line @typescript-eslint/no-explicit-any
}

export const SwiperEl = memo((props: SwiperProps) => {
	const { type = 'regular', images = [], speed = 300, alt = '', setSwiperInstance, handleSlideChange } = props

	return (
		<Swiper
			spaceBetween={1}
			slidesPerView={1}
			speed={speed}
			onSwiper={setSwiperInstance}
			onSlideChange={handleSlideChange}
		>
			{images.length ? (
				images.map((img, i) => {
					return (
						<SwiperSlide key={img}>
							<div className={cl.image}>
								<ProductImage src={img} alt={`${alt} - ${i}`} type={type} data-name="image" />
							</div>
						</SwiperSlide>
					)
				})
			) : (
				<SwiperSlide>
					<div className={cl.image}>
						<ProductImage type={type} />
					</div>
				</SwiperSlide>
			)}
		</Swiper>
	)
})
